import React, { useEffect, useRef, useState } from "react";
import { Router, Route, Redirect, Switch, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import leftIcon from "../_assets/images/left_icon.png";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { Button } from "../_components/button.component";
import { AnnouncementService } from "../_service/announcement.service";
import { Loader } from "../_components/loader.component";
import Table from "../_components/table.component";
import { TextInput } from "../_components/text-input.component";
import { TrackService } from "../_service/track.service";
import PlayImg from "../_assets/images/play.png";
import PauseImg from "../_assets/images/pause.png";
import { ActionModal } from "../_components/action-modal.component";
import TrackManagement from "../_components/track-management.component";

export const TRACK_MANAGEMENT_ROUTE = "/track-management";

let trackListGlobal = [];

function TrackManagementPageComponent({ user, history, addToast }) {
  const trackRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showAddTrack, setShowAddTrack] = useState(false);
  const [showEditTrack, setShowEditTrack] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [trackData, setTrackData] = useState({});
  const [isSongPlaying, setIsSongPlaying] = useState(false);
  const [trackInfo, setTrackInfo] = useState({});
  const [trackList, setTrackList] = useState([]);

  const [selectedIds, setSelectedIds] = useState([]);
  let location = useLocation();

  const [pageCount, setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);

  const categoriesLabels = {
    patientGratification: "Patient Gratification",
    copingwithGrief: "Coping With Grief",
    workRelationships: "Work Relationships",
    workLifeBalance: "Work-Life Balance",
    breakingRoutine: "Breaking Routine",
    slowingDown: "Slowing Down",
    rediscoveringPurpose: "Rediscovering Purpose",
    dailyFrustration: "Daily Frustrations",
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Image",
        accessor: "imageURL",
        Cell: (data, index) => {
          let toggle = false;
          return (
            <div>
              {/* {
								!isSongPlaying ? 
									<img src={PlayImg} className="absolute" key={index} onClick={() => playSong()} />
								: <></>
							}
							{
								isSongPlaying ? 
									<img src={PauseImg} className="absolute" key={index} onClick={() => pauseSong()} />
								: <></>
							} */}
              <img src={data.row?.values.imageURL} className="rounded-l" />
            </div>
          );
        },
      },
      {
        Header: "Title of track",
        accessor: "title",
        Cell: (data) => {
          return <div className="overflow-y-auto">{data.row.values.title}</div>;
        },
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: (data) => {
          return (
            <div className="overflow-y-auto">{data.row.values.description}</div>
          );
        },
      },
      {
        Header: "Category",
        accessor: "category",
        Cell: (data) => {
          return (
            <div className="overflow-y-auto">
              {categoriesLabels[data.row.values.category]}
            </div>
          );
        },
      },
      {
        Header: "Speaker",
        accessor: "speaker",
        Cell: (data) => {
          return (
            <div className="overflow-y-auto">{data.row.values.speaker}</div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "isActive",
        Cell: (data) => {
          let status = "";
          if (data.row?.values.isActive) {
            status = "Active";
          } else {
            status = "Inactive";
          }
          return (
            <div
              className={
                data.row?.values.isActive ? "text-green-500" : "text-red-500"
              }>
              {status}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "_id",
        Cell: (data, index) => {
          return (
            <div className="flex items-center">
              <button>
                {!data.row.original.isPlaying ? (
                  <img
                    src={PlayImg}
                    className="h-5"
                    onClick={() =>
                      playPauseSong(data.row.original, data.row.index, data)
                    }
                  />
                ) : (
                  <></>
                )}
                {data.row.original.isPlaying ? (
                  <img
                    src={PauseImg}
                    className="h-5"
                    onClick={() =>
                      playPauseSong(data.row.original, data.row.index, data)
                    }
                  />
                ) : (
                  <></>
                )}
              </button>
              <button
                onClick={() => handleEditTrack(data.row.original)}
                className="mx-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </button>
              <button onClick={() => handleDeleteTrack(data.row.values)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </button>
            </div>
          );
        },
      },
    ],
    [selectedIds]
  );

  useEffect(() => {
    getAllTracks();
  }, [selectedPage]);

  useEffect(() => {
    if (trackList) {
      trackList.forEach((source, i) => {
        source.audio.addEventListener("ended", () => {
          const updated = trackList.map((e) => {
            e.isPlaying = false;
            return e;
          });
          setTrackList(updated);
        });
        trackList[i].isPlaying ? source.audio.play() : source.audio.pause();
      });
    }
  }, [trackList, selectedIds]);

  useEffect(() => {
    if (!isSongPlaying) {
      return;
    }

    const closePlayListener = (e) => {
      setIsSongPlaying(false);
    };

    window.document.body.addEventListener("click", closePlayListener);

    return () => {
      window.document.body.removeEventListener("click", closePlayListener);
    };
  }, [isSongPlaying]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      stopCurrentPlayingSong();
    });
    return function cleanup() {
      unlisten();
    };
  }, []);

  const getAllTracks = async () => {
    setIsLoading(true);
    TrackService.getAllTracks(user, {
      page: selectedPage,
      limit: 5,
    })
      .then((resp) => {
        resp.tracks = resp.tracks.map((res) => ({
          ...res,
          isPlaying: false,
          audio: new Audio(res.mp3URL),
        }));
        trackListGlobal = resp.tracks;
        setPageCount(resp.totalPages);
        setIsLoading(false);
        setTrackList(resp.tracks);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const filter = (value) => {
    const keyword = value;
    if (keyword !== "") {
      const results = trackListGlobal.filter((tr) => {
        return tr.title.toLowerCase().includes(keyword.toLowerCase());
      });
      setTrackList(results);
    } else {
      setTrackList(trackListGlobal);
    }
    setSearchValue(keyword);
  };

  const handleDeleteTrack = (data) => {
    stopCurrentPlayingSong();
    setIsDeleteModalVisible(true);
    setTrackData(data);
  };

  const handleEditTrack = (data) => {
    stopCurrentPlayingSong();
    setShowAddTrack(false);
    setShowEditTrack(true);
    setTrackData(data);
  };

  const playPauseSong = (data, ind, tracks) => {
    let tracksData = tracks.data;
    const currentIndex = tracksData.findIndex((p) => p.isPlaying === true);
    if (currentIndex !== -1 && currentIndex !== ind) {
      tracksData[currentIndex].isPlaying = false;
      tracksData[ind].isPlaying = true;
      setIsSongPlaying(true);
    } else if (currentIndex !== -1) {
      tracksData[ind].isPlaying = false;
      setIsSongPlaying(false);
    } else {
      tracksData[ind].isPlaying = true;
      setIsSongPlaying(true);
    }
    trackListGlobal = tracksData;
    setSelectedIds((prvSelectedId) =>
      prvSelectedId.includes(data._id)
        ? prvSelectedId.filter((id) => id !== data._id)
        : [...prvSelectedId, data._id]
    );
    setTrackList(tracksData);
  };

  const onSubmitDelete = () => {
    TrackService.deleteTrack(user, trackData._id)
      .then((resp) => {
        addToast("Track deleted successfully", "", ToastTypes.success);
        const trackFilterData = trackList.filter(
          (tr) => tr._id != trackData._id
        );

        setIsDeleteModalVisible(false);
        setTrackData({});
        trackListGlobal = trackFilterData;
        setTrackList(trackFilterData);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const showAddTrackContent = () => {
    setShowEditTrack(false);
    setShowAddTrack(!showAddTrack);
  };

  const routingHandler = () => {
    setShowAddTrack(false);
    setShowEditTrack(false);
    if (!(showAddTrack || showEditTrack)) {
      history.push("/");
    } else {
      history.push("/track-management");
    }
  };

  const stopCurrentPlayingSong = () => {
    let tempTrakList = trackListGlobal;
    tempTrakList.forEach((trD) => {
      trD.isPlaying = false;
      trD.audio.pause();
      trD.audio.currentTime = 0;
    });
    setTrackList(tempTrakList);
    trackListGlobal = tempTrakList;
    setIsSongPlaying(false);
  };

  const handlePageClick = (direction) => {
    if (direction === "prev" && selectedPage !== 1) {
      stopPlayingSong();
      setSelectedPage(selectedPage - 1);
    }
    if (direction === "next" && selectedPage !== pageCount) {
      stopPlayingSong();
      setSelectedPage(selectedPage + 1);
    }
  };

  const stopPlayingSong = () => {
    setIsSongPlaying(false);
    let tempTrackData = trackList;
    const currentIndex = trackList.findIndex((p) => p.isPlaying === true);
    if (currentIndex !== -1) {
      tempTrackData[currentIndex].audio.pause();
    }
    tempTrackData.map((tr) => (tr.isPlaying = false));
    trackListGlobal = tempTrackData;
    setTrackList(tempTrackData);
  };

  return (
    <div className="page-container ml-auto px-9 py-6 org-details-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img src={leftIcon} alt="" onClick={() => routingHandler()} />
        <span
          className="ml-3 text-xl home-text"
          onClick={() => routingHandler()}>
          Home
        </span>
      </div>
      <div className="flex flex-wrap">
        {!(showAddTrack || showEditTrack) ? (
          <div
            className="bg-white rounded-xl w-full px-6 py-9"
            style={{ minHeight: "80vh" }}>
            <div>
              <div className="flex justify-between px-5">
                <p className="font-bold text-lg text-primary">
                  Track Management
                </p>
              </div>
              <>
                <div className="flex items-center justify-between px-5 pt-3">
                  <div className="table-actions-container">
                    <div className="relative text-gray-600 focus-within:text-gray-400">
                      <TextInput
                        type="text"
                        placeholder="Search Tracks"
                        containerClassName="flex-grow block"
                        className="py-2 rounded-lg"
                        value={searchValue}
                        onChange={(val) => filter(val)}
                      />
                      <span className="absolute flex inset-y-0 items-center pl-2 right-0">
                        <button
                          type="submit"
                          className="p-1 focus:outline-none focus:shadow-outline">
                          <svg
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            className="w-6 h-6">
                            <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                          </svg>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="">
                    <Button
                      label="Add New"
                      className="btn-primary px-6"
                      onClick={showAddTrackContent}
                    />
                  </div>
                </div>
                <div className="">
                  <div className="mt-5">
                    {trackList || !isLoading ? (
                      <div>
                        <Table
                          columns={columns}
                          data={trackList}
                          defaultPageSize={100}
                          pageSize={100}
                          showPagination={true}
                          imgPadding={false}
                          isLoading={isLoading}
                          pageCount={pageCount}
                          handlePageClick={handlePageClick}
                          selectedPage={selectedPage}
                        />
                        <ActionModal
                          active={isDeleteModalVisible}
                          setActive={setIsDeleteModalVisible}
                          onSubmit={onSubmitDelete}
                          header="You are deleting track :"
                          userName={
                            trackData && trackData?.title
                              ? trackData?.title
                              : ""
                          }
                          title="Are you sure you want to delete the record?"
                          btnColor="red"
                        />
                      </div>
                    ) : (
                      <div className="text-center">
                        <p className="text-primary">No Tracks Available</p>
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          </div>
        ) : (
          <TrackManagement
            user={user}
            addToast={addToast}
            showAddTrack={showAddTrack}
            setShowAddTrack={setShowAddTrack}
            showEditTrack={showEditTrack}
            setShowEditTrack={setShowEditTrack}
            setTrackList={setTrackList}
            trackList={trackList}
            trackData={trackData}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
});

const TrackManagementPage = withToast(
  connect(mapStateToProps)(TrackManagementPageComponent)
);

export default TrackManagementPage;
